import 'angular';

export default () => {
    return {
        serviceQuoteTempData: {
            id: undefined,
            vin: '',
            policyNumber: '',
            totalAmount: '',
            totalVAT: '',
            totalTTC: '',
            parts: '',
            partsTotalAmount: '',
            partsTotalDiscount: '',
            partsTotalVAT: '',
            partsTotalTTC: '',
            operations: '',
            operationsTotalAmount: '',
            operationsTotalDiscount: '',
            operationsTotalVAT: '',
            operationsTotalTTC: '',
        }
    };
};